<template>
    <div v-if="activeUrlExists && !loaderStore.isLoading">
      <v-btn variant="elevated" color="primary" @click="exportNotifications">
        <template v-if="!isMobile">
          Export Logs
        </template>
        <template v-else>
          <v-icon>mdi-bell-export</v-icon>
        </template>
      </v-btn>
    </div>
  </template>
  
  <script lang="ts" setup>
  import { computed } from 'vue';
  import { useDisplay } from 'vuetify';
  import { useActiveUrlStore } from '@/store/activeUrlStore';
  import { useLoaderStore } from '@/store/loaderStore';
  import exportNotificationsToJson from '@/composables/useExportNotificationsToJson';
  
  const activeUrlStore = useActiveUrlStore();
  const loaderStore = useLoaderStore();
  
  const activeUrlExists = computed(() => !!activeUrlStore.activeUrl);
  
  const { mobile } = useDisplay();
  const isMobile = computed(() => mobile.value);
  
  const exportNotifications = () => {
    exportNotificationsToJson();
  };
  </script>
  